import { connect } from 'react-redux';
import store from 'store';
import { barcodeAuthorize, checkin } from 'store/actions/auth';
import { addMessage } from 'store/actions/messages';
import BarcodeBase from '../../Auth/BarcodeBase';
import beep from 'assets/audio/beep';

const mapStateToProps = (state) => {
  const { isFetching } = state.auth;
  const { apiKey } = state.auth;

  return {
    loading: isFetching, // dont scan when we are doing other stuff
    apiKey,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    login: code => {
      return barcodeAuthorize(code)
      .then(json => {
        
        beep.play();

        const { access_civicrm, contact_id } = json.values;

        if (!access_civicrm) {
          throw new Error('User not authorized');
        }

        const state = store.getState();
        
        const { 
          auth: { contactId, apiKey },
          single: { extraContact },
        } = state;
        const { hasHousingCase } = extraContact.data;

        dispatch(checkin(contactId, apiKey, {
          custom_1324: contact_id, // Approved By
          custom_2444: hasHousingCase ? '1' : '0', // Has Housing case
        }));

        return json;
      })
      .catch(error => {
        dispatch(addMessage(error.message, 'error'));
        return false;
      });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BarcodeBase);